import { Header } from 'components';
import './style.scss';

interface IProps {
  title: string;
}

function Navbar(props: IProps) {
  return (
    <div className='navbar-cntr-SFKY'>
      <NavbarModule
        title={props.title}
        type='common'
      />
      <NavbarModule
        title={props.title}
        type='hidden'
      />
    </div>
  );
}

interface IModuleProps extends IProps {
  type: 'common' | 'hidden';
}

function NavbarModule(props: IModuleProps) {
  const className = props.type === 'common' ? 'navbar-pEC3o main-be5X' : 'navbar-pEC3o hidden-CAjl';

  return (
    <div className={className}>
      <Header
        size='bigger'
        className='frame-title-Uveb'
      >
        {props.title}
      </Header>
    </div>
  );
}

export default Navbar;
